const BLUE_COLOR = 'blue';
const RED_COLOR = 'red';
const GREEN_COLOR = 'green';
const YELLOW_COLOR = 'yellow';
const colorSequence = [BLUE_COLOR, RED_COLOR, GREEN_COLOR, YELLOW_COLOR];
const colorMap = {
  [RED_COLOR]: '#EA1D23',
  [GREEN_COLOR]: '#00A347',
  [BLUE_COLOR]: '#29ADFF',
  [YELLOW_COLOR]: '#DABC0F',
};
const isTabletWidth = window.innerWidth <= 992;
let defaultGameState = {
  hasGameStarted: false,
  activeTurn: 'user', // which player has the current turn, user/computer
  tokenOpenArr: [1, 6],
  tokenEligibleArr: [],
  playerTurns: 0,
  userDice: {
    first: null,
    second: null,
  },
  computerDice: {
    first: null,
    second: null,
  },
  userTokens: {},
  computerTokens: {},
  winner: null,
};
const LS_USER_INFO_KEY = '_LH_D_';
const userDiceRolledEvent = 'user:dice:rolled';
const computerDiceRolledEvent = 'computer:dice:rolled';
const userTurnActiveEvent = 'user:turn:active';
const computerTurnActiveEvent = 'computer:turn:active';
const userStateDesktop = [
  { left: '300px', top: '650px', isSafe: true },
  { left: '300px', top: '600px' },
  { left: '300px', top: '550px' },
  { left: '300px', top: '500px' },
  { left: '300px', top: '450px' },
  { left: '250px', top: '400px' },
  { left: '200px', top: '400px' },
  { left: '150px', top: '400px' },
  { left: '100px', top: '400px', isSafe: true },
  { left: '50px', top: '400px' },
  { left: '0px', top: '400px' },
  { left: '0px', top: '350px' },
  { left: '0px', top: '300px' },
  { left: '50px', top: '300px', isSafe: true },
  { left: '100px', top: '300px' },
  { left: '150px', top: '300px' },
  { left: '200px', top: '300px' },
  { left: '250px', top: '300px' },
  { left: '300px', top: '250px' },
  { left: '300px', top: '200px' },
  { left: '300px', top: '150px' },
  { left: '300px', top: '100px' },
  { left: '300px', top: '50px' },
  { left: '300px', top: '0px' },
  { left: '350px', top: '0px' },
  { left: '400px', top: '0px' },
  { left: '400px', top: '50px', isSafe: true },
  { left: '400px', top: '100px' },
  { left: '400px', top: '150px' },
  { left: '400px', top: '200px' },
  { left: '400px', top: '250px' },
  { left: '450px', top: '300px' },
  { left: '500px', top: '300px' },
  { left: '550px', top: '300px' },
  { left: '600px', top: '300px', isSafe: true },
  { left: '650px', top: '300px' },
  { left: '700px', top: '300px' },
  { left: '700px', top: '350px' },
  { left: '700px', top: '400px' },
  { left: '650px', top: '400px', isSafe: true },
  { left: '600px', top: '400px' },
  { left: '550px', top: '400px' },
  { left: '500px', top: '400px' },
  { left: '450px', top: '400px' },
  { left: '400px', top: '450px' },
  { left: '400px', top: '500px' },
  { left: '400px', top: '550px' },
  { left: '400px', top: '600px', isSafe: true },
  { left: '400px', top: '650px' },
  { left: '400px', top: '700px' },
  { left: '350px', top: '700px' },
  { left: '350px', top: '650px', isSafe: true },
  { left: '350px', top: '600px', isSafe: true },
  { left: '350px', top: '550px', isSafe: true },
  { left: '350px', top: '500px', isSafe: true },
  { left: '350px', top: '450px', isSafe: true },
  { left: '350px', top: '390px', isSafe: true },
];
const userStateMobile = [
  { left: '144px', top: '312px', isSafe: true },
  { left: '144px', top: '288px' },
  { left: '144px', top: '264px' },
  { left: '144px', top: '240px' },
  { left: '144px', top: '216px' },
  { left: '120px', top: '192px' },
  { left: '96px', top: '192px' },
  { left: '72px', top: '192px' },
  { left: '48px', top: '192px', isSafe: true },
  { left: '24px', top: '192px' },
  { left: '0px', top: '192px' },
  { left: '0px', top: '168px' },
  { left: '0px', top: '144px' },
  { left: '24px', top: '144px', isSafe: true },
  { left: '48px', top: '144px' },
  { left: '72px', top: '144px' },
  { left: '96px', top: '144px' },
  { left: '120px', top: '144px' },
  { left: '144px', top: '120px' },
  { left: '144px', top: '96px' },
  { left: '144px', top: '72px' },
  { left: '144px', top: '48px', isSafe: true },
  { left: '144px', top: '24px' },
  { left: '144px', top: '0px' },
  { left: '168px', top: '0px' },
  { left: '192px', top: '0px' },
  { left: '192px', top: '24px', isSafe: true },
  { left: '192px', top: '48px' },
  { left: '192px', top: '72px' },
  { left: '192px', top: '96px' },
  { left: '192px', top: '120px' },
  { left: '216px', top: '144px' },
  { left: '240px', top: '144px' },
  { left: '264px', top: '144px' },
  { left: '288px', top: '144px', isSafe: true },
  { left: '312px', top: '144px' },
  { left: '336px', top: '144px' },
  { left: '336px', top: '168px' },
  { left: '336px', top: '192px' },
  { left: '312px', top: '192px', isSafe: true },
  { left: '288px', top: '192px' },
  { left: '264px', top: '192px' },
  { left: '240px', top: '192px' },
  { left: '216px', top: '192px' },
  { left: '192px', top: '216px' },
  { left: '192px', top: '240px' },
  { left: '192px', top: '264px' },
  { left: '192px', top: '288px', isSafe: true },
  { left: '192px', top: '312px' },
  { left: '192px', top: '336px' },
  { left: '168px', top: '336px' },
  { left: '168px', top: '312px', isSafe: true },
  { left: '168px', top: '288px', isSafe: true },
  { left: '168px', top: '264px', isSafe: true },
  { left: '168px', top: '240px', isSafe: true },
  { left: '168px', top: '216px', isSafe: true },
  { left: '168px', top: '187px', isSafe: true },
];
const computerStateDesktop = [
  { left: '400px', top: '50px', isSafe: true },
  { left: '400px', top: '100px' },
  { left: '400px', top: '150px' },
  { left: '400px', top: '200px' },
  { left: '400px', top: '250px' },
  { left: '450px', top: '300px' },
  { left: '500px', top: '300px' },
  { left: '550px', top: '300px' },
  { left: '600px', top: '300px', isSafe: true },
  { left: '650px', top: '300px' },
  { left: '700px', top: '300px' },
  { left: '700px', top: '350px' },
  { left: '700px', top: '400px' },
  { left: '650px', top: '400px', isSafe: true },
  { left: '600px', top: '400px' },
  { left: '550px', top: '400px' },
  { left: '500px', top: '400px' },
  { left: '450px', top: '400px' },
  { left: '400px', top: '450px' },
  { left: '400px', top: '500px' },
  { left: '400px', top: '550px' },
  { left: '400px', top: '600px', isSafe: true },
  { left: '400px', top: '650px' },
  { left: '400px', top: '700px' },
  { left: '350px', top: '700px' },
  { left: '300px', top: '700px' },
  { left: '300px', top: '650px', isSafe: true },
  { left: '300px', top: '600px' },
  { left: '300px', top: '550px' },
  { left: '300px', top: '500px' },
  { left: '300px', top: '450px' },
  { left: '250px', top: '400px' },
  { left: '200px', top: '400px' },
  { left: '150px', top: '400px' },
  { left: '100px', top: '400px', isSafe: true },
  { left: '50px', top: '400px' },
  { left: '0px', top: '400px' },
  { left: '0px', top: '350px' },
  { left: '0px', top: '300px' },
  { left: '50px', top: '300px', isSafe: true },
  { left: '100px', top: '300px' },
  { left: '150px', top: '300px' },
  { left: '200px', top: '300px' },
  { left: '250px', top: '300px' },
  { left: '300px', top: '250px' },
  { left: '300px', top: '200px' },
  { left: '300px', top: '150px' },
  { left: '300px', top: '100px' },
  { left: '300px', top: '50px' },
  { left: '300px', top: '0px' },
  { left: '350px', top: '0px' },
  { left: '350px', top: '50px', isSafe: true },
  { left: '350px', top: '100px', isSafe: true },
  { left: '350px', top: '150px', isSafe: true },
  { left: '350px', top: '200px', isSafe: true },
  { left: '350px', top: '250px', isSafe: true },
  { left: '350px', top: '300px', isSafe: true },
];
const computerStateMobile = [
  { left: '192px', top: '24px', isSafe: true },
  { left: '192px', top: '48px' },
  { left: '192px', top: '72px' },
  { left: '192px', top: '96px' },
  { left: '192px', top: '120px' },
  { left: '216px', top: '144px' },
  { left: '240px', top: '144px' },
  { left: '264px', top: '144px' },
  { left: '288px', top: '144px', isSafe: true },
  { left: '312px', top: '144px' },
  { left: '336px', top: '144px' },
  { left: '336px', top: '168px' },
  { left: '336px', top: '192px' },
  { left: '312px', top: '192px', isSafe: true },
  { left: '288px', top: '192px' },
  { left: '264px', top: '192px' },
  { left: '240px', top: '192px' },
  { left: '216px', top: '192px' },
  { left: '192px', top: '216px' },
  { left: '192px', top: '240px' },
  { left: '192px', top: '264px' },
  { left: '192px', top: '288px', isSafe: true },
  { left: '192px', top: '312px' },
  { left: '192px', top: '336px' },
  { left: '168px', top: '336px' },
  { left: '144px', top: '336px' },
  { left: '144px', top: '312px', isSafe: true },
  { left: '144px', top: '288px' },
  { left: '144px', top: '264px' },
  { left: '144px', top: '240px' },
  { left: '144px', top: '216px' },
  { left: '120px', top: '192px' },
  { left: '96px', top: '192px' },
  { left: '72px', top: '192px' },
  { left: '48px', top: '192px', isSafe: true },
  { left: '24px', top: '192px' },
  { left: '0px', top: '192px' },
  { left: '0px', top: '168px' },
  { left: '0px', top: '144px' },
  { left: '24px', top: '144px', isSafe: true },
  { left: '48px', top: '144px' },
  { left: '72px', top: '144px' },
  { left: '96px', top: '144px' },
  { left: '120px', top: '144px' },
  { left: '144px', top: '120px' },
  { left: '144px', top: '96px' },
  { left: '144px', top: '72px' },
  { left: '144px', top: '48px', isSafe: true },
  { left: '144px', top: '24px' },
  { left: '144px', top: '0px' },
  { left: '168px', top: '0px' },
  { left: '168px', top: '24px', isSafe: true },
  { left: '168px', top: '48px', isSafe: true },
  { left: '168px', top: '72px', isSafe: true },
  { left: '168px', top: '96px', isSafe: true },
  { left: '168px', top: '120px', isSafe: true },
  { left: '168px', top: '144px', isSafe: true },
];

export {
  colorSequence,
  colorMap,
  isTabletWidth,
  defaultGameState,
  LS_USER_INFO_KEY,
  userStateDesktop,
  computerStateDesktop,
  userStateMobile,
  computerStateMobile,
  userDiceRolledEvent,
  computerDiceRolledEvent,
  userTurnActiveEvent,
  computerTurnActiveEvent,
};
